import image1 from "../../images/image1.png";
import image2 from "../../images/image2.png";
import image3 from "../../images/image3.png";
import image4 from "../../images/image4.png";
import image5 from "../../images/image5.png";
import image6 from "../../images/image6.png";
import image7 from "../../images/image7.png";
import image8 from "../../images/image8.png";
import image9 from "../../images/image9.png";
import image10 from "../../images/image10.png";
import image11 from "../../images/image11.png";
import image12 from "../../images/image12.png";
import image13 from "../../images/image13.png";
import image14 from "../../images/image14.png";
import image15 from "../../images/image15.png";

import thumb1 from "../../images/thumbnails/image1-thumbnail.jpg";
import thumb2 from "../../images/thumbnails/image2-thumbnail.jpg";
import thumb3 from "../../images/thumbnails/image3-thumbnail.jpg";
import thumb4 from "../../images/thumbnails/image4-thumbnail.jpg";
import thumb5 from "../../images/thumbnails/image5-thumbnail.jpg";
import thumb6 from "../../images/thumbnails/image6-thumbnail.jpg";
import thumb7 from "../../images/thumbnails/image7-thumbnail.jpg";
import thumb8 from "../../images/thumbnails/image8-thumbnail.jpg";
import thumb9 from "../../images/thumbnails/image9-thumbnail.jpg";
import thumb10 from "../../images/thumbnails/image10-thumbnail.jpg";
import thumb11 from "../../images/thumbnails/image11-thumbnail.jpg";
import thumb12 from "../../images/thumbnails/image12-thumbnail.jpg";
import thumb13 from "../../images/thumbnails/image13-thumbnail.jpg";
import thumb14 from "../../images/thumbnails/image14-thumbnail.jpg";
import thumb15 from "../../images/thumbnails/image15-thumbnail.jpg";

export const imageSliderData = [
	{ image: image1, thumbnail: thumb1, caption: "Catching rays" },
	{ image: image2, thumbnail: thumb2, caption: "Prague, Christmas Markets" },
	{ image: image3, thumbnail: thumb3, caption: "Catch and release" },
	{ image: image4, thumbnail: thumb4, caption: "I'm lunch" },
	{ image: image5, thumbnail: thumb5, caption: "Livingstone" },
	{ image: image6, thumbnail: thumb6, caption: "Chiang Mai" },
	{ image: image7, thumbnail: thumb7, caption: "Koh Samui, Night Markets" },
	{ image: image8, thumbnail: thumb8, caption: "Jellyfish Museum" },
	{ image: image9, thumbnail: thumb9, caption: "Bouldering" },
	{ image: image10, thumbnail: thumb10, caption: "The Algarve" },
	{ image: image11, thumbnail: thumb11, caption: "Koh Tao" },
	{ image: image12, thumbnail: thumb12, caption: "Hungry" },
	{ image: image13, thumbnail: thumb13, caption: "Pottery" },
	{ image: image14, thumbnail: thumb14, caption: "Doodling" },
	{ image: image15, thumbnail: thumb15, caption: "Cappadocia" },
];
